module.exports = __webpack_public_path__ + "static/colgadas-001.thumb-0e8bfbdca3ca21edd19ef8361937995f.jpg";